import { Component, HostListener, inject, OnInit } from '@angular/core';

import { RouterModule } from '@angular/router';

import { AuthService, AppInfoService } from '../../services';
import { DxButtonComponent } from 'devextreme-angular/ui/button';
import { DxTextBoxComponent } from 'devextreme-angular/ui/text-box';
import { DxValidatorComponent } from 'devextreme-angular/ui/validator';
import { NavigatorService } from '../../services/navigator.service';
import * as sha512 from 'js-sha512';
import { DxiValidationRuleComponent } from 'devextreme-angular/ui/nested';
import { ParametriPasswords } from '../../utils/ildato-gestione-password/parametri-passwords';
import notify from 'devextreme/ui/notify';
import { AggiornaPasswordModel } from '../../utils/ildato-gestione-password/aggiorna-password-model';
import { PopupPasswordScadutaComponent } from '../popup-password-scaduta/popup-password-scaduta.component';
import {
  DxLoadIndicatorComponent,
  DxLoadPanelComponent,
  DxValidationGroupComponent,
} from 'devextreme-angular';
import { environment } from 'src/environments/environment';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventType } from '@azure/msal-browser';
import { StorageService } from '../../services/storage.service';
import { RUOLO_OPERATORE_BASE } from 'src/app/consts/const';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  imports: [
    RouterModule,
    DxButtonComponent,
    DxTextBoxComponent,
    DxValidatorComponent,
    DxiValidationRuleComponent,
    PopupPasswordScadutaComponent,
    DxLoadPanelComponent,
    DxLoadIndicatorComponent,
    DxValidationGroupComponent,
  ],
  standalone: true,
})
export class LoginFormComponent implements OnInit {
  private authService = inject(AuthService);
  public appInfo = inject(AppInfoService);
  private ns = inject(NavigatorService);
  private msalService = inject(MsalService);
  private storageService = inject(StorageService);

  login = '';
  password = '';
  logoDitta: string;
  NomeEsteso: string;
  visibleLoadIndicatorLogin: boolean = false;
  disabledButtonLogin: boolean = false;
  loadPanelVisible = false;

  isPasswordScaduta = false;
  parametriPasswords: ParametriPasswords;

  hasLogin365 =
    environment.msClientId != undefined && environment.msClientId.length > 0;

  authBase: boolean = false;
  authAvanzato: boolean = false;

  ngOnInit(): void {
    this.authBase = environment.authBase;
    this.authAvanzato = environment.authAvanzato;
    this.msalService.instance.initialize();
    console.log(this.hasLogin365);
    this.msalService.instance.addEventCallback((event) => {
      switch (event.eventType) {
        case EventType.LOGIN_SUCCESS:
          const loginResult = event.payload as AuthenticationResult;
          console.log('Login riuscito:', loginResult.account);
          this.msalService.instance.setActiveAccount(loginResult.account);
          this.doLoginByEntraId(loginResult.idToken);
          break;

        // case EventType.LOGIN_FAILURE:
        //   console.error('Login fallito:', event.error);
        //   this.loadPanelVisible = false;
        //   notify("Login 365 fallito senza evento specifico!", "warning");
        //   break;

        case EventType.LOGOUT_SUCCESS:
          console.log('Logout riuscito');
          break;

        case EventType.ACQUIRE_TOKEN_SUCCESS:
          const tokenResult = event.payload as AuthenticationResult;
          console.log('Token acquisito...'); //, tokenResult.accessToken);
          this.doLoginByEntraId(tokenResult.idToken);
          break;

        case EventType.ACQUIRE_TOKEN_FAILURE:
          console.error('Errore nel token:', event.error);
          this.loadPanelVisible = false;
          notify('Login 365 fallito durante acquire token!', 'warning');
          break;

        case EventType.HANDLE_REDIRECT_END:
          console.log('Redirect completato');
          break;

        case EventType.HANDLE_REDIRECT_START:
          console.log('Redirect start');
          this.loadPanelVisible = true;
          break;

        case EventType.ACQUIRE_TOKEN_START:
          console.log('Acquisizione token...');
          this.loadPanelVisible = true;
          break;

        default:
          console.log('Evento MSAL:', event);
      }
    });
  }

  loginWithMicrosoft() {
    this.loadPanelVisible = true;
    this.msalService.loginRedirect({
      scopes: ['api://' + environment.msClientId + '/access_as_user'],
    });
  }

  @HostListener('window:keypress', ['$event'])
  onKeyPress(event) {
    //console.log(event);
    if (event.keyCode == 13) {
      setTimeout(() => {
        if (
          this.login.length > 0 &&
          this.password.length > 0 &&
          !this.isPasswordScaduta
        ) {
          this.onLoginClick();
        }
      }, 0);
    }
  }

  onLoginClick() {
    this.visibleLoadIndicatorLogin = true;
    this.disabledButtonLogin = true;
    const password512 = sha512.sha512(this.password);
    this.authService.logIn(this.login, password512).subscribe({
      next: (res) => {
        if (res.token != undefined) {
          if (
            this.storageService.utenteCorrente.ruoloString ==
            RUOLO_OPERATORE_BASE
          ) {
            this.ns.goToDashboardGiornaliera();
          } else {
            this.ns.goToHome();
          }
        } else if (res.token == undefined) {
          this.visibleLoadIndicatorLogin = false;
          this.disabledButtonLogin = false;
          if (res.needNewPassword && res.parametriPasswords) {
            //PASSWORD SCADUTA GESTIRE L'AGGIORNAMENTO
            this.isPasswordScaduta = true;
            this.parametriPasswords = res.parametriPasswords;
          }
        }
      },
      error: (error) => {
        if (error?.error?.title) {
          //const errT = error?.error?.text();
          // const errj = JSON.parse(errT);
          notify(error?.error?.title, 'error');
        } else {
          notify('Errore login', 'error');
        }
      },
    });
  }

  onPopupPasswordScadutaEvent(aggiornaPasswordData: AggiornaPasswordModel) {
    this.loadPanelVisible = true;
    const password512 = sha512.sha512(aggiornaPasswordData.password);
    const newPassword512 = sha512.sha512(aggiornaPasswordData.newPassword);
    this.authService
      .logInWithNewPassword(
        aggiornaPasswordData.username,
        password512,
        newPassword512,
      )
      .subscribe({
        next: (res) => {
          this.loadPanelVisible = false;
          if (res.token != undefined) {
            if (
              this.storageService.utenteCorrente.ruoloString ==
              RUOLO_OPERATORE_BASE
            ) {
              this.ns.goToDashboardGiornaliera();
            } else {
              this.ns.goToHome();
            }
          }
        },
        error: (error) => {
          this.loadPanelVisible = false;
          if (error?.error?.title) {
            notify(error?.error?.title, 'error');
          } else {
            notify('Errore aggiornamento password', 'error');
          }
        },
      });
  }

  doLoginByEntraId(accToken: string) {
    this.authService.loginByEntraId(accToken).subscribe(
      (res) => {
        this.loadPanelVisible = false;
        if (res.token != undefined) {
          if (
            this.storageService.utenteCorrente.ruoloString ==
            RUOLO_OPERATORE_BASE
          ) {
            this.ns.goToDashboardGiornaliera();
          } else {
            this.ns.goToHome();
          }
        } else if (res?.error?.title) {
          notify(res?.error?.title, 'warning', 5000);        
        } else {
          notify('Errore gestione token con entraID', 'warning', 5000);
        }
      },
      async (error) => {
        if (error?.error) {
          let errT = await error?.error?.text();
          let errj = JSON.parse(errT);
          notify(errj?.title, 'error');
        } else {
          notify('Errore login tramite entraid', 'error');
        }
      },
    );
  }
}
